import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
    selector: 'app-radio-buttons',
    templateUrl: './radio-buttons.component.html',
    styleUrls: ['./radio-buttons.component.scss'],
    standalone: false
})
export class RadioButtonsComponent implements OnInit, OnChanges {

  @Input() title?;
  @Input() options: string[];
  @Input() level;
  @Input() component?;
  @Input() popupContent = null;
  @Input() disabled? = false;
  @Output() selected = new EventEmitter();

  public clicked: any;
  public showPopup = false;

  constructor() {
  }

  ngOnInit() {
    this.clicked = new Array(this.options.length);
    this.options.map((b, i) => b === this.level ? this.clicked[i] = true : this.clicked[i] = false);
  }
  ngOnChanges() {
    this.clicked = new Array(this.options.length);
    this.options.map((b, i) => b === this.level ? this.clicked[i] = true : this.clicked[i] = false);
  }

  public openPopup(e) {
    this.showPopup = true;
  }

  public closePopup(e) {
    this.showPopup = false;
  }

  selectOption(value) {
    this.selected.emit(value);
    this.options.map((b, i) => b === value ? this.clicked[i] = true : this.clicked[i] = false);
  }

}
